import { Directive } from '@angular/core';

@Directive({
  selector: '[snTimestamp]',
  host: {
    class: 'sn-player__timestamp',
  },
})
export class SnPlayerTimestampDirective {
  constructor() {}
}
